const isValidMinMaxBet = (currency: CashierCurrency | BtcUnit) =>
  currency !== 'uBTC';

export default isValidMinMaxBet;
